import React from 'react'

import { $changeZIndex } from './../../mixin/mixin-jquery'

const Alertbox = ({data, dispatchReducer, yesFunc, noFunc}) => {

  const _handleClose = function(e) {
    e.preventDefault();

    dispatchReducer({
      type: 'ABOX::CLOSE'
    });

    // remove container's z-index from override everything
    $changeZIndex($('#main-wrapper'), '');
  }

  const _handleYes = function(e) {
    e.preventDefault();
    yesFunc();
  }

  const _handleNo = function(e) {
    e.preventDefault();
    noFunc();
  }

  return <div className="lightbox-units">
    <div className="lightbox-units-inner alertbox-inner">

      <a href="#" className="lightbox-units-close" onClick={_handleClose}>&#215;</a>

      <h3 className="heading">{data.heading}</h3>
      <p>{data.message}</p>
      <div className="clearfix">
        <a href="#" className="btn btn--secondary alertbox-yes" onClick={ _handleYes }>Remove</a>
        <a href="#" className="alertbox-no" onClick={ noFunc ?  _handleNo : _handleClose }>Cancel</a>
      </div>
    </div>
  </div>;
}

Alertbox.propTypes = {
  data:             React.PropTypes.object.isRequired,
  yesFunc:          React.PropTypes.func,
  noFunc:           React.PropTypes.func,
  dispatchReducer:  React.PropTypes.func.isRequired
}

export default Alertbox